export const COMMAND_CENTER_APP_KEY = "command_center_app_id";

const pendingWrites = new WeakMap();

function validAppId(id) {
  return typeof id === "string" && /^[a-z0-9][a-z0-9_-]{0,63}$/.test(id);
}

export async function readCommandCenterApp(database) {
  try {
    await pendingWrites.get(database);
    const id = await database.getItem(COMMAND_CENTER_APP_KEY);
    return validAppId(id) ? id : "";
  } catch (_error) {
    return "";
  }
}

export function saveCommandCenterApp(database, id = "") {
  const write = (pendingWrites.get(database) || Promise.resolve()).then(async () => {
    try {
      if (validAppId(id)) await database.setItem(COMMAND_CENTER_APP_KEY, id);
      else await database.removeItem(COMMAND_CENTER_APP_KEY);
    } catch (_error) {}
  });
  pendingWrites.set(database, write);
  return write;
}

export function resolveCommandCenterApp(id, catalog) {
  if (catalog.status !== "ready") return id;
  return catalog.apps.some((app) => app.id === id) ? id : "";
}